import { IDLE_TIMEOUT_MS, INTERACTION_EVENTS } from './config.js';
import { loadClarity, loadGoogleAnalytics, loadGoogleTagManager } from './providers.js';

/**
 * Delays all third-party analytics until the visitor's first interaction (scroll, click, touch,
 * key press) or a generous timeout. This keeps the main thread free during the critical
 * rendering window that PageSpeed measures.
 */
export function setupAnalytics() {
    window.dataLayer = window.dataLayer || [];
    // gtag.js only understands `arguments` objects in the data layer, so this cannot be an arrow function.
    window.gtag = function () {
        window.dataLayer.push(arguments);
    };

    let triggered = false;

    const trigger = () => {
        if (triggered) {
            return;
        }

        triggered = true;
        INTERACTION_EVENTS.forEach((event) => window.removeEventListener(event, trigger));

        loadWhenIdle();
    };

    const listen = () => {
        INTERACTION_EVENTS.forEach((event) => {
            window.addEventListener(event, trigger, { once: true, passive: true });
        });

        setTimeout(trigger, IDLE_TIMEOUT_MS);
    };

    if (document.readyState === 'complete') {
        listen();
    } else {
        window.addEventListener('load', listen, { once: true });
    }
}

function loadWhenIdle() {
    const load = () => {
        loadGoogleAnalytics();
        loadGoogleTagManager();
        loadClarity();
    };

    if ('requestIdleCallback' in window) {
        requestIdleCallback(load, { timeout: IDLE_TIMEOUT_MS });
    } else {
        setTimeout(load, IDLE_TIMEOUT_MS);
    }
}
